import { useParams } from 'react-router-dom';

import { AppMembersPage } from '~/components/pages/AppMembersPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppMembersRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppMembersPage appId={appId} />
    </DashboardTemplate>
  );
};
